import React from 'react';
import './details-item.scss';

interface IProps {
    title: string | JSX.Element;
    className?: string;
}

const DetailsItem = (props: React.PropsWithChildren<IProps>) => {
    return (
        <div className='details-item'>
            <h5>{props.title}</h5>
            <div className={props.className || 'details'}>
                {props.children}
            </div>
        </div>
    );
};

export { DetailsItem };